export default __webpack_public_path__ + "static/media/Barbara.cafbbf1b.png";